// Shimmer skeletons matching 12-loaders.html sections 4, 5, and 7.

export function SkeletonFlightCard() {
  return (
    <div className="skeleton-flight-card">
      <div>
        <div className="skeleton-flight-row">
          <span className="skeleton skeleton-circle" />
          <div>
            <span className="skeleton skeleton-line lg" style={{ width: 60 }} />
            <div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: 80 }} /></div>
          </div>
          <span className="skeleton" style={{ height: 1, alignSelf: "center" }} />
          <div>
            <span className="skeleton skeleton-line lg" style={{ width: 60 }} />
            <div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: 80 }} /></div>
          </div>
        </div>
        <div className="skeleton-meta-row">
          <span className="skeleton" />
          <span className="skeleton" />
          <span className="skeleton" style={{ width: 100 }} />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
        <span className="skeleton skeleton-line lg" style={{ width: 90 }} />
        <span className="skeleton skeleton-line sm" style={{ width: 120 }} />
        <span className="skeleton" style={{ width: 80, height: 32, borderRadius: 999, marginTop: 4 }} />
      </div>
    </div>
  );
}

export function SkeletonBookingRow() {
  return (
    <div className="skeleton-booking-row">
      <div><span className="skeleton skeleton-line lg" style={{ width: 80 }} /><div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: 60 }} /></div></div>
      <div><span className="skeleton skeleton-line" style={{ width: "90%" }} /><div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: "70%" }} /></div></div>
      <div><span className="skeleton skeleton-line" style={{ width: "80%" }} /><div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: "60%" }} /></div></div>
      <div><span className="skeleton" style={{ width: 92, height: 24, borderRadius: 999 }} /></div>
      <div style={{ textAlign: "right" }}><span className="skeleton skeleton-line lg" style={{ width: 70 }} /></div>
      <span />
    </div>
  );
}

// For inside FareRulesDrawer while the POST /fare-rules/ is loading.
export function SkeletonRuleBlocks() {
  return (
    <>
      {[0, 1].map((i) => (
        <div key={i} className="rule-block" style={{ background: "var(--bg-2)" }}>
          <div className="rule-block-head">
            <span className="skeleton skeleton-circle" style={{ width: 32, height: 32 }} />
            <div>
              <span className="skeleton skeleton-line" style={{ width: 130 }} />
              <div style={{ marginTop: 6 }}><span className="skeleton skeleton-line sm" style={{ width: 180 }} /></div>
            </div>
          </div>
          <div className="rule-section">
            <span className="skeleton skeleton-line sm" style={{ width: 90, marginBottom: 6 }} />
            <div><span className="skeleton skeleton-line" style={{ width: "100%" }} /></div>
            <div style={{ marginTop: 4 }}><span className="skeleton skeleton-line" style={{ width: "75%" }} /></div>
          </div>
          <div className="rule-section">
            <span className="skeleton skeleton-line sm" style={{ width: 90, marginBottom: 6 }} />
            <div><span className="skeleton skeleton-line" style={{ width: "100%" }} /></div>
            <div style={{ marginTop: 4 }}><span className="skeleton skeleton-line" style={{ width: "60%" }} /></div>
          </div>
        </div>
      ))}
    </>
  );
}
